import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { RegistroCondominioDTO } from "types/dto/RegistroCondominioDTO";
import { RegistroUnidadeDTO } from "types/dto/RegistroUnidadeDTO";
import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

export const ProcessosJudiciaisSchema = yup.object().shape({
  condominio: yup
    .mixed<SelectOptionType<RegistroCondominioDTO>>()
    .required(mensagemDeErroPadrao("Condominio")),
  unidade: yup
    .mixed<SelectOptionType<RegistroUnidadeDTO>>()
    .required(mensagemDeErroPadrao("Unidade")),
  numeroProcesso: yup.string().required(mensagemDeErroPadrao("Número do processo")),
  possuiAcordosVinculados: yup.boolean().default(false),
  acordos: yup
    .array()
    .of(yup.mixed<SelectOptionType<RegistroAcordoDTO>>())
    .when(["possuiAcordosVinculados"], ([possuiAcordosVinculados], schema) => {
      if (possuiAcordosVinculados) {
        return schema
          .test("acordos-nulos", mensagemDeErroPadrao("Acordos"), (acordos) => {
            if (acordos) {
              return acordos?.length > 0;
            }
          })
          .required(mensagemDeErroPadrao("Acordos"));
      } else {
        return schema;
      }
    }),
});
